export default "__VITE_ASSET__CsdqkI8V__"